class ShowCollages {
    constructor() {
        this.sectionWrapper = document.querySelector('.js-section-wrapper');
        this.btns = document.querySelectorAll('.js-button-collage');
        this.btnsToMain = document.querySelectorAll('.js-to-main');
        this.pos;
        this.id;

        this.events();
    }

    events = () => {
        for(const btn of this.btns) {
            btn.addEventListener('click', e => this.showCollage(btn));
        }

        for(const btnToMain of this.btnsToMain) {
            btnToMain.addEventListener('click', () => this.hideCollage(btnToMain));
        }
    };

    collage = () => {
        return document.querySelector(`#${this.id}`);
    }

    showCollage = (btn) => {
        this.pos = window.pageYOffset;
        this.id = btn.dataset.id;
        this.sectionWrapper.style.display = 'none';
        this.collage(this.id).classList.add('collage-wrapper--show');
        window.scrollTo(0, 0);
    };

    hideCollage = () => {
        this.sectionWrapper.removeAttribute('style');
        this.collage(this.id).classList.remove('collage-wrapper--show');
        window.scrollTo(0, this.pos);
    }
}

new ShowCollages();
